import { createContext, useContext } from "react";
import type { Classification, PersonalWorkspaceRuntime, WorkspaceCommand, WorkspaceSnapshot } from "./workspace-api";
export interface WorkspaceContextValue {
  session: PersonalWorkspaceRuntime["api"]; userId: string | null; snapshot: WorkspaceSnapshot | null; fresh: boolean; busy: boolean; error: string;
  canRetry: boolean; last: WorkspaceCommand | null; pending: WorkspaceCommand | null;
  refresh(): Promise<boolean>; start(clientId: string, classification: Classification): void;
  stop(): void; reviewSwitch(clientId: string, classification: Classification): void; confirmSwitch(): void; cancelSwitch(): void; retry(): void;
  correct(id: string, revision: number, start: string, stop: string, reason: string): Promise<boolean>;
}
export const WorkspaceContext = createContext<WorkspaceContextValue | null>(null);
export const usePersonalWorkspace = () => useContext(WorkspaceContext);
